"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledNavigationMenuTitle = exports.StyledNavigationMenuTitleText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../../../helpers");
const Text_1 = require("../../../Text");
exports.StyledNavigationMenuTitleText = (0, styled_components_1.default)(Text_1.Text) `
    height: ${helpers_1.SIZE_XL};
    line-height: ${helpers_1.SIZE_XL};
    color: ${({ theme }) => theme.colorTextNavSecondary};
`;
exports.StyledNavigationMenuTitle = styled_components_1.default.div `
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin: 0;
    padding-left: ${helpers_1.SPACING_M};
    padding-right: ${helpers_1.SPACING_XXL};
`;
//# sourceMappingURL=NavigationMenuTitle.styles.js.map